export enum RECEIVE_STEPS {
  CHOOSE_ASSET = 'RECEIVE_CHOOSE_ASSET',
  FORM = 'RECEIVE_FORM',
  ATTENTION = 'RECEIVE_ATTENTION',
}
